import React, { useContext, useRef } from 'react';
import { Observation } from '@area-monitoring/react-components';
import styled, { useTheme } from 'styled-components';
import { ShAuthContext } from '../../../contexts/shAuthContext';
import useAreaMonitoringDimensions from '../../../hooks/useAreaMonitoringDimensions';
import dayjs from 'dayjs';

const ObservationWrap = styled.div`
  width: 100%;
  height: 100%;
`;

export default function ObservationComponent({ height, width, field, date, performanceIndex, language }) {
  const { shAuthToken } = useContext(ShAuthContext);
  const observationRef = useRef();
  const { width: observationWidth, height: observationHeight } = useAreaMonitoringDimensions(observationRef);
  const theme = useTheme();

  return (
    <ObservationWrap ref={(el) => (observationRef.current = el)}>
      {observationRef.current && (
        <Observation
          baseUrl={process.env.REACT_APP_SENTINEL2_WMS_ENDPOINT}
          layerId={performanceIndex}
          shAuthToken={shAuthToken}
          key={date}
          language={language}
          date={dayjs(date).format('YYYY-MM-DD')}
          width={width ?? observationWidth}
          height={height ?? observationHeight}
          geometries={[
            {
              geometry: field.geometry,
              style: {
                strokeColor: theme.fieldColor,
                lineWidth: theme.fieldWeight,
              },
            },
          ]}
          paddingXPercent={100}
          paddingYPercent={100}
          onClick={() => null}
        />
      )}
    </ObservationWrap>
  );
}
